import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { EditorComponentContract } from '../EditorComponentContract'
import { PricingTableFactory } from '../../factories/PricingTableFactory'
export class PricingTable extends EditorComponentContract {
	constructor() {
		super(Variations)
		this.htmlBuilder = HtmlBuilder
		this.factory = new PricingTableFactory
	}

	elementIds() {
		return [
			'id', 'featuredId', 'priceId', 'descriptionId', 'titleId',
			'buttonId', 'listId', 'headerId', 'contentId', 'footerId',
		]
	}

	elementClasses() {
		return [
			'featuredContainerClasses', 'featuredClasses', 'classes', 'titleContainerClasses', 'footerClasses',
			'priceContainerClasses', 'priceClasses', 'descriptionContainerClasses', 'descriptionClasses',
			'titleClasses', 'buttonClasses', 'iconClasses', 'listClasses', 'headerClasses', 'contentClasses',
		]
	}

	elementContents() {
		return [
			'featured', 'featuredText', 'hasTitle', 'title', 'buttonLink', 'price',
			'recurrency', 'headerBlocks', 'contentBlocks', 'footerBlocks', 'listItems',
			'hasDescription', 'buttonText', 'description', 'hasList', 'class', 'icon',
		]
	}

	elementStyles() {
		return [
			{id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
			{id: 'featuredId', element: 'id', styles: 'featuredStyles', selector: '#', variation: null},
			{id: 'priceId', element: 'id', styles: 'priceStyles', selector: '#', variation: null},
			{id: 'descriptionId', element: 'id', styles: 'descriptionStyles', selector: '#', variation: null},
			{id: 'titleId', element: 'id', styles: 'titleStyles', selector: '#', variation: null},
			{id: 'buttonId', element: 'id', styles: 'buttonStyles', selector: '#', variation: null},
			{element: 'class', styles: 'iconStyles', selector: '.wf-pricing-table-icon'},
			{id: 'listId', element: 'id', styles: 'listStyles', selector: '#', variation: null},
			{id: 'headerId', element: 'id', styles: 'headerStyles', selector: '#', variation: null},
			{id: 'contentId', element: 'id', styles: 'contentStyles', selector: '#', variation: null},
			{id: 'footerId', element: 'id', styles: 'footerStyles', selector: '#', variation: null},
		]
	}

	info() {
		return {
			name: 'PricingTable',
			icon: 'fa-dollar-sign',
			variations: this.variationsInfo()
		}
	}
}